
<main class="c-main" role="main">

    <div class="c-page-other2manual">
      <div class="container u-pb60">
        <div class="row mobile--orange u-pt30">
          <div class="col-md-8">

      
            <h2 class="o-title js-txt3">{{'PersonalFormVisitorPortal.title'| translate}}</h2>
            <p class="o-text js-txt4">{{'PersonalFormVisitorPortal.subtitle'| translate}}.</p>
          </div>
        </div>
        <div class="row" style="padding: 30px;" *ngIf="!accessPage">
            <div class="col-md-12">
            <p>{{'PersonalFormVisitorPortal.completeCaptcha'| translate}} </p>
        </div>
            <div class="col-md-12">
                <div class="card mt-3" align="center">
                    <div class="card-body">
                        <re-captcha (resolved)="resolved($event)" [siteKey]="key"></re-captcha>
                    </div>
                </div>
            </div>
          </div>
        <div *ngIf="accessPage">
          <form  class="o-form"[formGroup]="personalForm" (ngSubmit)="onSubmit()">
        <div class="row">
          <div class="col-md-12 u-pt20 u-pb50">
            <div class="c-card c-card--detail">
              <h2 class="o-title o-title--medium o-title--orange js-txt5">{{'PersonalFormVisitorPortal.requestDetail'| translate}}</h2>
              <div class="row u-pt20">
                <div class="col-md-3"><strong class="js-txt9">{{'PersonalFormVisitorPortal.labelSite'| translate}}:</strong>
                  <p> {{Request.site}}</p>
                </div>
                <div class="col-md-3"><strong class="js-txt10">{{'PersonalFormVisitorPortal.labelZone'| translate}}:</strong>
                  <p>{{Request.zone}}</p>
                </div>
                <div class="col-md-2" *ngIf="Request.SubZone"><strong class="js-txt11">{{'PersonalFormVisitorPortal.labelSubzone'| translate}}:</strong>
                  <p>{{Request.SubZone}}</p>
                </div>
                <div class="col-md-2"><strong class="js-txt6">{{'PersonalFormVisitorPortal.labelFrom'| translate}}:</strong>
                  <p>{{Request.from }}</p>
                </div>
                <div class="col-md-2"><strong class="js-txt7">{{'PersonalFormVisitorPortal.labelTo'| translate}}:</strong>
                  <p>{{Request.to }}</p>
                </div>
                <div class="col-md-12 u-pt20"><strong class="js-txt12">{{'PersonalFormVisitorPortal.purpuse'| translate}}:</strong>
                  <p class="js-txt13">{{Request.purpuse}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="hr orange"></div>
        
          <div class="row u-pt20">
            <div class="col-md-12 u-pb20">
              <h2 class="o-title o-title--medium o-title--orange js-txt14">{{'PersonalFormVisitorPortal.titlePersonalInfo'| translate}}</h2>
              <p class="o-text js-txt15">{{'PersonalFormVisitorPortal.subtitlePersonalInfo'| translate}}.</p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label class="o-title o-title--label o-title--required js-txt16" id="FirstName">{{'PersonalFormVisitorPortal.labelName'| translate}}:</label>
                <input class="o-form__input" type="text" formControlName="firstName"  id="firstName">
                <div *ngIf="personalForm.controls['firstName'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                  <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>{{'PersonalFormVisitorPortal.requiredInfo'| translate}}</mat-error></h5></span>
                </div>
              </div>
              
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label class="o-title o-title--label o-title--required">{{'PersonalFormVisitorPortal.labelName'| translate}}:</label>
                <input class="o-form__input" type="text"  id="lastName" formControlName="lastName" >
                <div *ngIf="personalForm.controls['lastName'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                  <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>{{'PersonalFormVisitorPortal.requiredInfo'| translate}}</mat-error></h5></span>
                </div>
              </div>
        
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 u-pb10" >
              <div class="form-group u-pb0">
                <label class="o-title o-title--label o-title--required " id="country" name="country">{{'PersonalFormVisitorPortal.labelCountry'| translate}}:</label>
                <label class="o-form__input" style="cursor: no-drop;">  {{personalForm.controls.country.value}} </label>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group u-pb0">
                <label class="o-title o-title--label o-title--required" >{{'PersonalFormVisitorPortal.documentType'| translate}}</label>
                
                <label *ngIf="personalForm.controls.documentType.value=='nationalId'" class="o-form__input" style="cursor: no-drop;">  RUT </label>
                <label *ngIf="personalForm.controls.documentType.value=='PassportNumber'" class="o-form__input" style="cursor: no-drop;"> {{'PersonalFormVisitorPortal.labelPassport'| translate}} </label>
                <label *ngIf="!(personalForm.controls.documentType.value==='nationalId' || personalForm.controls.documentType.value==='PassportNumber' )" class="o-form__input" style="cursor: no-drop;">  {{personalForm.controls.documentType.value}} </label>
              </div>
            </div>
          </div>
      

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label class="o-title o-title--label o-title--required js-txt24">{{'PersonalFormVisitorPortal.labelRutpassport'| translate}}:</label>
                <label class="o-form__input" style="cursor: no-drop;">  {{personalForm.controls.documentNumber.value}} </label>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label class="o-title o-title--label o-title--required js-txt26">{{'PersonalFormVisitorPortal.labelPhone'| translate}}:</label>
                <input class="o-form__input" type="tel" formControlName="phone"  id="phone"  >
                <div *ngIf="personalForm.controls['phone'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                  <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>{{'PersonalFormVisitorPortal.requiredInfo'| translate}}</mat-error></h5></span>
                </div>
                <div *ngIf="personalForm.controls['phone'].hasError('pattern') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                  <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>{{'PersonalFormVisitorPortal.notValidNumber'| translate}}</mat-error></h5></span>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12" 
          style="padding-bottom: 15px;padding-bottom: 15px;padding-right: 0px;padding-left: 0px;" >
            <div class="form-group ">
              <label class="o-title o-title--label o-title--required">{{'PersonalFormVisitorPortal.selectGender'| translate}}</label>
            </div>
            <form class="o-form" [formGroup]="personalForm">
           <div class="o-form__tabSH u-mb30" id="radioManualBulk">

                           <input class="form-check-input" type="radio" formControlName="gender" value="Male" id="Male">
                           <label class="transition equalHM" for="Male">
                             <strong >{{'PersonalFormVisitorPortal.optMale'| translate}}</strong>
                            </label>

                           <input class="form-check-input" type="radio" formControlName="gender" value="Female" id="Female">
                           <label class="transition equalHM" for="Female" style="white-space: pre-wrap">
                            <strong >{{'PersonalFormVisitorPortal.optFemale'| translate}}</strong>
                          </label>
                          <input class="form-check-input" type="radio" formControlName="gender" value="Other" id="Other">
                          <label class="transition equalHM" for="Other" style="white-space: pre-wrap">
                           <strong >{{'PersonalFormVisitorPortal.optOther'| translate}}</strong>
                         </label>
           </div>
       </form>
       
       <div *ngIf="personalForm.controls['gender'].hasError('required') && submited" 
       style="width:100%; background-color: #F2F0E9" align="center;">
        <span>
          <h5 style="padding: 15px;">
            <mat-error style=" white-space: normal; ">
              <i class="icon icon-close"></i>{{'PersonalFormVisitorPortal.requiredInfo'| translate}}
            </mat-error>
          </h5>
        </span>
      </div>

       </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label class="o-title o-title--label  js-txt28">{{'PersonalFormVisitorPortal.labelCompany'| translate}}:</label>
                <input class="o-form__input" type="text" formControlName="company"  id="company" >
                <!-- <div *ngIf="personalForm.controls['company'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                  <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>{{'PersonalFormVisitorPortal.requiredInfo'| translate}}</mat-error></h5></span>
                </div> -->
              </div>
            
            </div>
            <div class="col-md-6">
              <div class="form-group u-pb20">
                <label class="o-title o-title--label js-txt30">{{'PersonalFormVisitorPortal.orgHealthSafe'| translate}}: <svg matTooltip="{{'PersonalFormVisitorPortal.tooltipMedicalOrganization' | translate}}​​" width="1em" height="1em" viewBox="0 0 16 16" 
                  class="bi bi-question-circle ptooltip--static ptooltip" fill="currentColor" xmlns="http://www.w3.org/2000/svg">

                      <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
  
                      <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
  
                    </svg>
                </label>  <!--   on class to required: "o-title--required"-->
                <input class="o-form__input" type="text" formControlName="safetyOrganization"  id="safetyOrganization" >
                <!-- <div *ngIf="personalForm.controls['safetyOrganization'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                  <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{'PersonalFormVisitorPortal.requiredInfo'| translate}}</mat-error></h5></span>
                </div> -->
              </div>
            </div>

          </div>
          <div class="row u-pt20">
            <div class="col-md-12">
              <h2 class="o-title o-title--medium js-txt37">{{'PersonalFormVisitorPortal.emergencyContact'| translate}}</h2>
              <p class="o-text">{{'PersonalFormVisitorPortal.emergencyInfo'| translate}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label class="o-title o-title--label o-title--required js-txt38">{{'PersonalFormVisitorPortal.labelName'| translate}}:</label>
                <input class="o-form__input" type="text" formControlName="eCfullName"  id="eCfullName" >
                <div *ngIf="personalForm.controls['eCfullName'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                  <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>{{'PersonalFormVisitorPortal.requiredInfo'| translate}}</mat-error></h5></span>
                </div>
              </div>
    
              
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label class="o-title o-title--label o-title--required js-txt40">{{'PersonalFormVisitorPortal.labelPhone'| translate}}:</label>
                <input class="o-form__input" type="tel" formControlName="eCphone"  id="eCphone" >
                <div *ngIf="personalForm.controls['eCphone'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                  <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>{{'PersonalFormVisitorPortal.requiredInfo'| translate}}</mat-error></h5></span>
                </div>
                <div *ngIf="personalForm.controls['eCphone'].hasError('pattern') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                  <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>{{'PersonalFormVisitorPortal.notValidNumber'| translate}}</mat-error></h5></span>
                </div>
              </div>
            
            </div>
          </div>

          <hr>
         
          <div class="row">
            <div class="row" *ngIf="qualificationDummyEnabled===true">
              <div class="col-md-12 u-pt20 ">
                <div class="c-card c-card--detail">
                  <h2 class="o-title o-title--medium o-title--orange js-txt5">{{'PersonalFormVisitorPortal.qualificationDummy'| translate}} </h2>
                  <div class="row u-pt20">
                    <div class="col-md-12" *ngIf="lang==='es'">
                      <strong class="js-txt9">{{'PersonalFormVisitorPortal.labelName'| translate}}:</strong>
                      <p> {{qualificationDummy.nameEs}}</p>
                    </div>
                    <div class="col-md-12 " *ngIf="lang==='en'">
                      <strong class="js-txt9">{{'PersonalFormVisitorPortal.labelName'| translate}} :</strong>
                      <p> {{qualificationDummy.nameEn}}</p>
                    </div>
                    <div class="col-md-12 u-pt20" >
                      <strong class="js-txt10">{{'PersonalFormVisitorPortal.labelEmail'| translate}}:</strong>
                      <p>{{qualificationDummy.email}}</p>
                    </div>
                    <div class="col-md-12 u-pt20" *ngIf="lang==='en'">
                      <strong class="js-txt12">{{'PersonalFormVisitorPortal.labelDescription'| translate}}:</strong>
                      <p class="js-txt13">{{qualificationDummy.descriptionEn}}</p>
                    </div>
                    <div class="col-md-12 u-pt20" *ngIf="lang==='es'">
                      <strong class="js-txt12">Descripcion:</strong>
                      <p class="js-txt13">{{qualificationDummy.descriptionEs}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr *ngIf="qualificationDummyEnabled===true">
   
            <div class="col-md-12">
              <h2 class="o-title o-title--medium js-txt37">{{'PersonalFormVisitorPortal.securityCode'| translate}}</h2>
              <p class="o-text">{{'PersonalFormVisitorPortal.securityCodeSub'| translate}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <input class="o-form__input" type="text" formControlName="verificationCode"  id="verificationCode" name="verificationCode">
                <div *ngIf="personalForm.controls['verificationCode'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                  <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{'PersonalFormVisitorPortal.requiredInfo'| translate}}</mat-error></h5></span>
                </div>
              </div>
              
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 u-pt50">
              <div class="o-form__checkbox u-mb20">
                <input type="checkbox" value="value" formControlName="confirm" name="confirm" id="confirm" required ><span></span>
                <a class="open_modal" (click)="openDialog()" data="terms" style="cursor:pointer">{{'PersonalFormVisitorPortal.confirmTerms'| translate}}.</a>
                <div *ngIf="personalForm.controls['confirm'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                  <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>{{'PersonalFormVisitorPortal.requiredInfo'| translate}}</mat-error></h5></span>
                </div>
              </div>
             
             </div>
          </div>
          <br>
          <div>
            
            <button class="btn btn--primary" >{{'PersonalFormVisitorPortal.btnGenerate'| translate}}</button>
          </div>
        </form>
      </div>
    </div>
</div>
  </main>
  